<template>
  <div class="flex flex-col">
    <h2>Roles</h2>

    <router-link
      v-if="hasPermission('edit_roles')"
      :to="{ name: 'rolesCreateForm' }"
      class="primary-button mx-0 mt-2"
      >Crear Rol</router-link
    >

    <div class="card mt-6">
      <table class="table-auto text-sm mt-2 bg-white">
        <thead class="text-left">
          <tr class="bg-gray-100">
            <th class="p-2 rounded-l-lg">ID</th>
            <th class="p-2">Rol</th>
            <th class="p-2 rounded-r-lg">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="role in roles" :key="role.id" class="table-row">
            <td class="table-cell">
              {{ role.id }}
            </td>
            <td class="table-cell">
              {{ role.name }}
            </td>
            <td class="table-cell">
              <div class="flex space-x-1">
                <router-link
                  :to="{
                    name: 'rolesDetail',
                    params: { id: role.id },
                  }"
                  class="secondary-button"
                  >Detalle</router-link
                >
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="loading" class="flex w-full h-full items-center">
        <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  name: "Roles",

  data() {
    return {
      roles: null,
      loading: false,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "roles");

    this.loadRoles();
  },

  methods: {
    async loadRoles() {
      this.loading = true;

      try {
        this.roles = await api.roles.getAll();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },
  },
};
</script>